import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
